import http from 'axios'

export const getAvailable1300Numbers = () => ({
  type: 'NUMBERS_1300/GET_AVAILABLE_NUMBERS',
  payload: http({
    method: 'GET',
    url: 'api/v1/numbers/1300/available',
  }),
})



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers1300/Numbers1300.actions.js